import landing from '@/locales/ni/landing'
import resultOrder from '@/locales/ni/result-order'
import invoice from '@/locales/ni/invoice'
import invoiceMcw from '@/locales/ni/invoice-mcw'
import currency from '@/locales/ni/currency'
import genericError from '@/locales/ni/generic-error'

export default {
  landing,
  resultOrder,
  invoice,
  invoiceMcw,
  currency,
  genericError
}
